import React from "react"
import { graphql } from "gatsby"
import { SimpleTextFieldsFragment } from "../../../../../../graphql-types"
import sanitizeHtml from "sanitize-html"
import * as styles from "./simple-text.module.scss"
type SimpleTextProps = {
  data: SimpleTextFieldsFragment
}

const SimpleText: React.FC<SimpleTextProps> = ({ data }) => {
  const sanitizeHtmlWithImages = content =>
    sanitizeHtml(content, {
      allowedTags: sanitizeHtml.defaults.allowedTags.concat(["img"]).concat(["p"]),
      allowedAttributes: {
        ...sanitizeHtml.defaults.allowedAttributes,
        img: (sanitizeHtml.defaults.allowedAttributes.img || []).concat(["src", "alt", "width", "height", "title"]),
        p: (sanitizeHtml.defaults.allowedAttributes.p || []).concat(["style"]),
        table: (sanitizeHtml.defaults.allowedAttributes.table || []).concat(["style", "border"]),
        tbody: (sanitizeHtml.defaults.allowedAttributes.tbody || []).concat(["style", "width", "height"]),
        tr: (sanitizeHtml.defaults.allowedAttributes.tr || []).concat(["style", "width", "height"]),
        td: (sanitizeHtml.defaults.allowedAttributes.td || []).concat(["style", "width", "height"]),
        span: (sanitizeHtml.defaults.allowedAttributes.span || []).concat(["style", "width", "height"]),
        li: (sanitizeHtml.defaults.allowedAttributes.li || []).concat(["style"]),
        ul: (sanitizeHtml.defaults.allowedAttributes.ul || []).concat(["style"]),
        ol: (sanitizeHtml.defaults.allowedAttributes.ol || []).concat(["style"]),
        blockquote: (sanitizeHtml.defaults.allowedAttributes.blockquote || []).concat(["style"]),
        div: (sanitizeHtml.defaults.allowedAttributes.div || []).concat(["style"]),
      },
    })

  return (
    <div className={styles.container}>
      <p
        className={styles.simpleText}
        key={data.id}
        dangerouslySetInnerHTML={{
        __html: sanitizeHtmlWithImages(data.simpleContent).replace(new RegExp("<p></p>", "g"), "<br>"),
      }}
    />
    </div>
  )
}

export const fragments = graphql`
  fragment SimpleTextFields on DatoCmsSimpleTextContent {
    id
    simpleContent
  }
`

export default SimpleText
